import React, { useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers';
import { createStripeProductCopy } from 'services';
import { showError, showSuccess } from 'utils';
import { useHistory } from 'react-router-dom';
import ActionButton from 'components/ActionButton';

const CreateProductCopyModal = ({ show, handleClose, stripeProductId }) => {
  const [apiError, setApiError] = useState('');
  const [copyLoading, setCopyLoading] = useState(false);
  const history = useHistory();

  const schema = yup.object().shape({
    name: yup.string().required('Name is required'),
  });

  const { register, handleSubmit, formState: { errors }} = useForm({
    resolver: yupResolver(schema),
  });


  const createStripeProductCopyFn = async (name: string) => {
    setCopyLoading(true);
    try {
      const response = await createStripeProductCopy(stripeProductId, name);
      showSuccess('Copy created successfully.');
      history.push(`/stripe-products/${response?.slug}`);
    } catch (e) {
      showError(e);
    } finally {
      setCopyLoading(false);
    }
  };

  const onSubmit = async (data) => {
    console.log(data);
    try {
      await createStripeProductCopyFn(data.name);
      handleClose();
    } catch (error) {
      setApiError('Error creating product');
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Create Product</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group controlId="name">
            <Form.Label>Name</Form.Label>
            <input
              type="text"
              name='name'
              className='form-control'
              placeholder="Enter name"
              ref={register}
            />
            <Form.Control.Feedback type="invalid">
              {errors.name?.message}
            </Form.Control.Feedback>
          </Form.Group>
          {apiError && <Alert variant="danger">{apiError}</Alert>}
          <Button variant="success" type="submit" disabled={copyLoading}>
            {copyLoading ? 'Creating...' : 'Create'}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateProductCopyModal;
